import React, { useEffect,useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { deleteBuildingAdmin, getBuildingById } from '../../store/buildings';
import { hasManagerAccess } from '../../utils/permissions';


function BuildingDetail() {
  const { id } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const [building, setBuilding] = useState(null);
  const [loading, setLoading] = useState(true);
//   const building = useSelector(state => state.buildings.find(b => b.id === parseInt(id)));
  const sessionUser = useSelector((state) => state.session.user);

  useEffect(() => {
    const fetchBuilding = async () => {
      try {
        const buildingData = await dispatch(getBuildingById(id));
        setBuilding(buildingData);
      } catch (error) {
        console.error("Error fetching Building:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchBuilding();
  }, [id, dispatch]);

//   useEffect(() => {
//     if (!building) {
//       dispatch(fetchBuildingsAdmin());
//     }
//   }, [dispatch, building]);

  const handleDelete = async () => {
    if (window.confirm('Are you sure you want to delete this building?')) {
      try {
        await dispatch(deleteBuildingAdmin(id));
        history.push('/');
      } catch (error) {
        console.error('Error deleting building:', error);
      }
    }
  };



    if (loading) {
        return <div className="p-5 text-7xl">Loading...</div>;
        }

        if (!building) {
            return <div className="p-5 text-7xl">Building not found</div>;
          }

  return (
    <div className="p-5 min-h-[calc(100vh-100px)] flex flex-col">
      <div className="max-w-6xl mx-auto w-full bg-white rounded-lg shadow-md p-8">
        <div className="mb-8">
          <h2 className="text-6xl font-bold text-blue-600">Building Detail</h2>
        </div>

        <div className="bg-gray-50 rounded-lg p-6 mb-8">
          <div className="space-y-4 text-2xl">

            <p className="flex items-center">
              <span className="font-semibold w-40">Building Name:</span>
              <span id='building_name'>{building.building_name}</span>
            </p>
            <p className="flex items-center">
              <span className="font-semibold w-40">Doors:</span>
              <span id='building_door_number'>{building.building_door_number}</span>
            </p>
            <p className="flex items-center">
              <span className="font-semibold w-40">Created:</span>
              <span id='created_at'>{new Date(building.created_at).toLocaleString()}</span>
            </p>
            <p className="flex items-center">
              <span className="font-semibold w-40">Updated:</span>
              <span id='updated_at'>{new Date(building.updated_at).toLocaleString()}</span>
            </p>
          </div>
        </div>

        <div className="flex justify-between items-center">
          <button
            id='back-building-button'
            onClick={() => history.push('/')}
            className="px-8 py-4 text-3xl text-gray-700 bg-gray-200 rounded-lg transition-all duration-200
              hover:bg-gray-300 hover:shadow-md hover:scale-[1.02]"
          >
            Back
          </button>
          <div className="space-x-4">
            <button
              id='update-building-button'
              onClick={() => history.push(`/buildings/${id}/edit`)}
              className="inline-block px-6 py-3 text-2xl text-white bg-blue-500 rounded-lg transition-all duration-200
                hover:bg-blue-600 hover:shadow-md hover:scale-[1.02]"
            >
              Update
            </button>
            {hasManagerAccess(sessionUser) && (
              <button
                id='delete-building-button'
                onClick={handleDelete}
                className="px-6 py-3 text-2xl text-white bg-red-500 rounded-lg transition-all duration-200
                  hover:bg-red-600 hover:shadow-md hover:scale-[1.02]"
            >
              Delete
            </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default BuildingDetail;
